export const berekenBreedte = (breedteInput) => {
  const breedte = breedteInput > 1000 ? 1000 : breedteInput < 100 ? 100 : breedteInput;
    const plankDikte = 140; // Breedte van de zijplanken
    const plankTussen = 215 + 8; // Breedte van de planken ertussen
    
    // Basisbreedte is de twee zijplanken
    const basisBreedte = 2 * plankDikte;
    
    // Bereken x door de tussenruimte van de totale breedte af te trekken en te delen door de breedte van een plank
    let aantal_planken = Math.round((breedte*10/2 - basisBreedte) / plankTussen);
    
    // Corrigeer breedte naar de dichtstbijzijnde toegestane waarde
    const gecorrigeerdeBreedte = (basisBreedte + aantal_planken * plankTussen)*2;
    
    return {
      gecorrigeerdeBreedte,
      aantal_planken,
    };
  }
  
  